/* eslint-disable no-lonely-if */
/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
import React from "react";
import { Checkbox } from "antd";
import ModuleHeader from "./ModuleHeader";
import BatteryIcon from "../../../Common/Svgs/BatteryIcon";
import { batteryPermissions } from "./data";
import PermissionTitle from "./PermissionTitle";
import { PERMISSIONS } from "../../Login/constants";
import {
  batteryAddEditDelete,
  batteryAddService,
  batteryRequest,
  batteryViewQR,
} from "./permissionFunctions";

const CONDITIONS = {
  VIEW_AND_EDIT: [PERMISSIONS.BATTERY_VIEW, PERMISSIONS.BATTERY_NO_ACCESS],

  REMOVE_ALL: [
    PERMISSIONS.BATTERY_ADD,
    PERMISSIONS.BATTERY_EDIT,
    PERMISSIONS.BATTERY_DELETE,
    PERMISSIONS.BATTERY_ADD_TO_SERVICE,
    PERMISSIONS.BATTERY_VIEW_QR,
    PERMISSIONS.BATTERY_VIEW,
    PERMISSIONS.BATTERY_VIEW_AND_EDIT,
    PERMISSIONS.BATTERY_NO_ACCESS,
    PERMISSIONS.BATTERY_NO_SERVICE,
    PERMISSIONS.BATTERY_NO_QR,
    PERMISSIONS.BATTERY_REQUEST,
    PERMISSIONS.BATTERY_NO_REQUEST,
  ],
};

const BatteryPermissions = ({ permissions, setPermissions }) => {
  // check if the permissions needs to be disabled
  const disabled = CONDITIONS.VIEW_AND_EDIT.some((d) =>
    permissions.includes(d),
  );

  const handleModulePermission = (permissionId) => {
    let local = [];

    if (permissionId === PERMISSIONS.BATTERY_VIEW_AND_EDIT) {
      local = permissions.filter(
        (item) => !CONDITIONS.VIEW_AND_EDIT.includes(item),
      );
    }

    // removing all the battery permissions
    if (permissionId === PERMISSIONS.BATTERY_VIEW) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    // removing all the battery permissions
    if (permissionId === PERMISSIONS.BATTERY_NO_ACCESS) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    setPermissions([...local, permissionId]);
  };

  const handleIndividualPermission = (permissionId) => {
    let local = [];
    if (permissions.includes(permissionId)) {
      local = permissions.filter((item) => item !== permissionId);
      setPermissions(local);
    } else {
      // handling multiple insertions for battery add, edit, delete
      if (permissionId === PERMISSIONS.BATTERY_ADD) {
        batteryAddEditDelete({ setPermissions });
      } else if (
        permissionId === PERMISSIONS.BATTERY_ADD_TO_SERVICE ||
        permissionId === PERMISSIONS.BATTERY_NO_SERVICE
      ) {
        // handling either add or don't add to service
        batteryAddService({
          current: permissionId,
          permissions,
          setPermissions,
        });
      } else if (
        permissionId === PERMISSIONS.BATTERY_VIEW_QR ||
        permissionId === PERMISSIONS.BATTERY_NO_QR
      ) {
        // handling either view or don't view QR
        batteryViewQR({ current: permissionId, permissions, setPermissions });
      }
      // handling either request batteries or no request batteries
      else if (
        permissionId === PERMISSIONS.BATTERY_REQUEST ||
        permissionId === PERMISSIONS.BATTERY_NO_REQUEST
      ) {
        batteryRequest({
          current: permissionId,
          permissions,
          setPermissions,
        });
      } else {
        setPermissions((prev) => [...prev, permissionId]);
      }
    }
  };

  return (
    <div>
      <ModuleHeader
        module="Batteries"
        icon={<BatteryIcon className="w-4 h-4 stroke-primary fill-none" />}
      />
      {/* main module permission */}
      <div className="w-full h-[60px]">
        <div
          className="flex items-center w-full h-full border-b"
          style={{
            background: "#FAF2D8",
            borderColor: "#FAD152",
          }}
        >
          <div
            className="w-[40%] border-r py-3 px-6"
            style={{
              borderColor: "#FAD152",
            }}
          >
            <PermissionTitle
              title={batteryPermissions[0].title}
              description={batteryPermissions[0].description}
            />
          </div>

          <div className="w-[60%] h-full flex items-center">
            {batteryPermissions[0].options.map((option) => {
              // rendering empty div for layout consistency
              if (!option) {
                return (
                  <div
                    className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                    style={{
                      borderColor: "#FAD152",
                    }}
                  />
                );
              }

              const selected = permissions.includes(option.permissionId);

              return (
                <div
                  key={option.text}
                  className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                  style={{
                    borderColor: "#FAD152",
                  }}
                >
                  <Checkbox
                    checked={selected}
                    onClick={() => handleModulePermission(option.permissionId)}
                  />
                  <p
                    className={`font-poppins text-xs ${
                      selected ? "font-medium" : "font-normal"
                    }`}
                  >
                    {option.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* individual functionality permission */}
      <div className="w-full">
        {batteryPermissions.slice(1).map((item) => {
          return (
            <div
              key={item.id}
              className="flex items-center w-full h-[60px] border-b"
              style={{
                borderColor: "#DFDFDF",
              }}
            >
              <div
                className="w-[40%] h-full border-r py-3 px-6"
                style={{
                  borderColor: "#DFDFDF",
                }}
              >
                <PermissionTitle
                  title={item.title}
                  description={item.description}
                />
              </div>

              <div className="w-[60%] h-full flex items-center">
                {item.options.map((option, idx) => {
                  // rendering empty div for layout consistency
                  if (!option) {
                    return (
                      <div
                        key={idx}
                        className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                        style={{
                          borderColor: "#DFDFDF",
                        }}
                      />
                    );
                  }

                  const selected = permissions.includes(option.permissionId);

                  // if the permission is view only, remove pointer events and add an opacity
                  return (
                    <div
                      key={option.text}
                      className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                      style={{
                        borderColor: "#DFDFDF",
                        opacity: disabled && 0.5,
                        pointerEvents: disabled && "none",
                      }}
                    >
                      {/* if the permissions should be disabled then it should not
                          show any tick mark else show the selected tick mark */}
                      <Checkbox
                        checked={disabled ? false : selected}
                        onClick={() =>
                          handleIndividualPermission(option.permissionId)
                        }
                      />
                      <p
                        className={`font-poppins text-xs
                            ${selected ? "font-medium" : "font-normal"}
                            `}
                      >
                        {option.text}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BatteryPermissions;
